export const environment = {
  production: true,
  naybrsAwsApi: 'https://api0.naybrs.com/v1',
};
